/* Supplement Daddy — brand layer behaviour.
   Deliberately small: no framework, no dependencies. */
(function () {
  'use strict';

  /* Re-running init() (theme editor fires shopify:section:load) must not
     bind the same listeners twice — double-bound arrows advance by two. */
  function once(el, key) {
    if (!el) return false;
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  /* ---- sticky header shadow ---- */
  function stickyHeader() {
    var head = document.querySelector('.sd-head');
    if (!head) return;
    var tick = false;
    function upd() {
      head.classList.toggle('is-stuck', window.scrollY > 8);
      tick = false;
    }
    window.addEventListener('scroll', function () {
      if (!tick) { tick = true; window.requestAnimationFrame(upd); }
    }, { passive: true });
    upd();
  }

  /* ---- rotating announcement messages ---- */
  function announcement() {
    var rot = document.querySelector('[data-sd-ann]');
    if (!rot) return;
    var msgs = rot.querySelectorAll('.sd-ann__msg');
    if (msgs.length < 2) { if (msgs[0]) msgs[0].classList.add('is-on'); return; }
    var i = 0;
    msgs[0].classList.add('is-on');
    setInterval(function () {
      msgs[i].classList.remove('is-on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on');
    }, 4200);
  }

  /* ---- mobile drawer ---- */
  function drawer() {
    var el = document.querySelector('[data-sd-drawer]');
    if (!el) return;
    function open() { el.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { el.classList.remove('is-open'); document.body.style.overflow = ''; }

    document.querySelectorAll('[data-sd-drawer-open]').forEach(function (b) {
      b.addEventListener('click', open);
    });
    el.querySelectorAll('[data-sd-drawer-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.classList.contains('is-open')) close();
    });
  }

  /* ---- scroll reveal ---- */
  function reveal() {
    var items = document.querySelectorAll('.sd-rv');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var d = en.target.getAttribute('data-sd-delay') || 0;
        setTimeout(function () { en.target.classList.add('is-in'); }, Number(d));
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    items.forEach(function (n) { io.observe(n); });
  }

  /* ---- track order: hand the ID to the configured courier ---- */
  function trackOrder() {
    var form = document.querySelector('[data-sd-track]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[name="sd-track-id"]');
      var id = (input && input.value || '').trim();
      if (!id) { if (input) input.focus(); return; }
      var base = form.getAttribute('data-sd-track') || '';
      window.open(base.indexOf('{id}') > -1 ? base.replace('{id}', encodeURIComponent(id))
                                            : base + encodeURIComponent(id), '_blank', 'noopener');
    });
  }

  /* ---- hero showcase rotator ---- */
  function heroShots() {
    var frame = document.querySelector('[data-sd-hero-frame]');
    if (!frame) return;
    var slides = frame.querySelectorAll('.sd-hero__slide');
    if (slides.length < 2) return;
    var dots = frame.querySelectorAll('[data-sd-hero-dots] button');
    var cap = frame.querySelector('[data-sd-hero-cap]');
    var i = 0, timer;

    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      if (cap && dots[i]) {
        var t = dots[i].getAttribute('data-title'), sub = dots[i].getAttribute('data-sub');
        var b = cap.querySelector('b'), sm = cap.querySelector('small');
        if (b && t) b.textContent = t;
        if (sm) sm.textContent = sub || '';
      }
    }
    function start() { stop(); timer = setInterval(function () { go(i + 1); }, 5000); }
    function stop() { if (timer) clearInterval(timer); }

    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(Number(d.getAttribute('data-i'))); start(); });
    });
    frame.addEventListener('mouseenter', stop);
    frame.addEventListener('mouseleave', start);
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
  }

  /* ---- shoppable video rail ---- */
  function shoppableVideo() {
    var root = document.querySelector('[data-sd-svid]');
    if (!root) return;
    var rail = root.querySelector('[data-sd-svid-rail]');
    var prev = root.querySelector('[data-sd-svid-prev]');
    var next = root.querySelector('[data-sd-svid-next]');
    var videos = rail ? rail.querySelectorAll('video') : [];

    /* play only what is on screen; a wall of autoplaying video kills scroll perf */
    if (videos.length && 'IntersectionObserver' in window &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) {
            v.muted = v.dataset.sdUnmuted !== '1';
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.45 });
      videos.forEach(function (v) {
        v.muted = true; v.loop = true; v.playsInline = true;
        v.setAttribute('playsinline', '');
        io.observe(v);
      });
    }

    /* per-reel sound toggle — only one reel audible at a time */
    root.querySelectorAll('[data-sd-sound]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var media = btn.closest('.sd-reel__media');
        var v = media && media.querySelector('video');
        if (!v) return;
        var turningOn = v.muted;
        if (turningOn) {
          videos.forEach(function (o) {
            o.muted = true; o.dataset.sdUnmuted = '0';
            var b = o.closest('.sd-reel__media');
            b = b && b.querySelector('[data-sd-sound]');
            if (b) b.innerHTML = btn.dataset.offIcon || b.innerHTML;
          });
        }
        v.muted = !turningOn ? true : false;
        v.dataset.sdUnmuted = v.muted ? '0' : '1';
        btn.setAttribute('aria-label', v.muted ? 'Unmute' : 'Mute');
        btn.classList.toggle('is-on', !v.muted);
        if (!v.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    });

    /* arrows */
    function step() {
      var card = rail.querySelector('.sd-reel');
      return card ? card.getBoundingClientRect().width + 12 : 240;
    }
    function sync() {
      if (!prev || !next) return;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.hidden = rail.scrollLeft <= 2;
      next.hidden = rail.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollLeft -= step() * 2; });
    if (next) next.addEventListener('click', function () { rail.scrollLeft += step() * 2; });
    if (rail) { rail.addEventListener('scroll', sync, { passive: true }); sync(); }
    window.addEventListener('resize', sync);
  }

  /* ---- hero banner carousel ---- */
  function heroSlides() {
    document.querySelectorAll('[data-sd-hs]').forEach(function (root) {
      var slides = root.querySelectorAll('.sd-hs__slide');
      if (slides.length < 2) return;
      if (!once(root, 'sdHsBound')) return;
      var dots = root.querySelectorAll('[data-sd-hs-dots] button');
      var prev = root.querySelector('[data-sd-hs-prev]');
      var next = root.querySelector('[data-sd-hs-next]');
      var delay = Number(root.getAttribute('data-autoplay') || 0) * 1000;
      var i = 0, timer = null;

      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      }
      function start() {
        stop();
        if (!delay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = setInterval(function () { go(i + 1); }, delay);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      if (prev) prev.addEventListener('click', function () { go(i - 1); start(); });
      if (next) next.addEventListener('click', function () { go(i + 1); start(); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { go(Number(d.getAttribute('data-i'))); start(); });
      });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      /* swipe */
      var x0 = null;
      root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) go(dx < 0 ? i + 1 : i - 1);
        x0 = null; start();
      });
      go(0); start();
    });
  }

  /* ---- generic rail carousel (categories, best sellers) ---- */
  function carousels() {
    document.querySelectorAll('[data-sd-car]').forEach(function (root) {
      var rail = root.querySelector('[data-sd-car-rail]');
      if (!rail) return;
      if (!once(root, 'sdCarBound')) return;
      var prev = root.querySelector('[data-sd-car-prev]');
      var next = root.querySelector('[data-sd-car-next]');
      var delay = Number(root.getAttribute('data-autoplay') || 0) * 1000;
      var timer = null;

      /* Looping rails duplicate their cards once, then wrap scrollLeft by the
         width of the original run so the row never reaches an edge. */
      var loop = rail.hasAttribute('data-sd-loop') && rail.children.length > 1;
      var runCount = 0;
      var runWidth = 0;
      var settle = null;

      function cloneRun() {
        if (!loop || rail.dataset.sdLoopRun) return;
        var originals = Array.prototype.slice.call(rail.children);
        runCount = originals.length;
        originals.forEach(function (node) {
          var copy = node.cloneNode(true);
          copy.setAttribute('data-sd-clone', '');
          copy.setAttribute('aria-hidden', 'true');
          rail.appendChild(copy);
        });
        rail.dataset.sdLoopRun = String(runCount);
      }
      function measure() {
        if (!loop) return;
        runCount = Number(rail.dataset.sdLoopRun || 0);
        var first = rail.children[0];
        var mirror = rail.children[runCount];
        runWidth = first && mirror ? mirror.offsetLeft - first.offsetLeft : 0;
      }
      function jumpTo(x) {
        var keep = rail.style.scrollBehavior;
        rail.style.scrollBehavior = 'auto';
        rail.scrollLeft = x;
        rail.style.scrollBehavior = keep;
      }
      /* Pull the rail back into the first run before a step would leave it. */
      function normalize(dir) {
        if (!loop || runWidth <= 0) return;
        var x = rail.scrollLeft;
        if (dir < 0 && x < 2) jumpTo(x + runWidth);
        else if (dir > 0 && x >= runWidth - 2) jumpTo(x - runWidth);
      }
      function step() {
        var card = rail.firstElementChild;
        if (!card) return 260;
        var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || 14) || 14;
        return card.getBoundingClientRect().width + gap;
      }
      function atEnd() { return rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2; }
      function sync() {
        if (loop) {
          if (prev) prev.hidden = false;
          if (next) next.hidden = false;
          return;
        }
        if (prev) prev.hidden = rail.scrollLeft <= 2;
        if (next) next.hidden = atEnd();
      }
      function nudge(dir) {
        if (loop) {
          measure();
          normalize(dir);
          rail.scrollBy({ left: dir * step(), behavior: 'smooth' });
          return;
        }
        if (dir > 0 && atEnd()) { rail.scrollLeft = 0; return; }
        rail.scrollLeft += dir * step();
      }
      /* Free scrolling (touch, trackpad) wraps once the gesture settles. */
      function wrapWhenIdle() {
        if (!loop) return;
        clearTimeout(settle);
        settle = setTimeout(function () {
          measure();
          if (runWidth <= 0) return;
          var x = rail.scrollLeft;
          if (x >= runWidth) jumpTo(x - runWidth);
          else if (x < 1) jumpTo(runWidth);
        }, 140);
      }
      function start() {
        stop();
        if (!delay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = setInterval(function () { nudge(1); }, delay);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      if (prev) prev.addEventListener('click', function () { nudge(-1); start(); });
      if (next) next.addEventListener('click', function () { nudge(1); start(); });
      rail.addEventListener('scroll', function () { sync(); wrapWhenIdle(); }, { passive: true });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      rail.addEventListener('touchstart', stop, { passive: true });
      window.addEventListener('resize', function () { measure(); sync(); });

      cloneRun(); measure(); sync(); start();
    });
  }

  /* ---- video reviews: video rail synced to the review panel ---- */
  function videoReviews() {
    document.querySelectorAll('[data-sd-vr]').forEach(function (root) {
      if (!once(root, 'sdVrBound')) return;
      var items  = root.querySelectorAll('[data-sd-vr-item]');
      var panels = root.querySelectorAll('[data-sd-vr-panel]');
      var rail   = root.querySelector('[data-sd-vr-rail]');
      var prev   = root.querySelector('[data-sd-vr-prev]');
      var next   = root.querySelector('[data-sd-vr-next]');
      if (!items.length) return;
      var i = 0;

      function videoOf(n) { return n ? n.querySelector('video') : null; }

      function show(n) {
        i = (n + items.length) % items.length;
        items.forEach(function (el, k) {
          el.classList.toggle('is-on', k === i);
          var v = videoOf(el);
          if (!v) return;
          if (k === i) {
            v.muted = v.dataset.sdUnmuted === '1';
            var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
          } else { v.pause(); v.muted = true; }
        });
        panels.forEach(function (el, k) { el.classList.toggle('is-on', k === i); });
        var active = items[i];
        if (active && rail) {
          rail.scrollTo({ left: active.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
        }
      }

      items.forEach(function (el, k) {
        el.addEventListener('click', function (e) {
          if (e.target.closest('[data-sd-vr-pause]') || e.target.closest('[data-sd-vr-mute]')) return;
          show(k);
        });
        var pause = el.querySelector('[data-sd-vr-pause]');
        var mute  = el.querySelector('[data-sd-vr-mute]');
        if (pause) pause.addEventListener('click', function (e) {
          e.stopPropagation();
          var v = videoOf(el); if (!v) return;
          if (v.paused) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else v.pause();
        });
        if (mute) mute.addEventListener('click', function (e) {
          e.stopPropagation();
          var v = videoOf(el); if (!v) return;
          v.muted = !v.muted;
          v.dataset.sdUnmuted = v.muted ? '0' : '1';
          mute.classList.toggle('is-on', !v.muted);
        });
      });

      /* delegated: survives the arrows being moved or re-rendered */
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-sd-vr-prev]')) { e.preventDefault(); show(i - 1); return; }
        if (e.target.closest('[data-sd-vr-next]')) { e.preventDefault(); show(i + 1); }
      });

      /* only run the active video while the section is on screen */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var v = videoOf(items[i]);
            if (!v) return;
            if (en.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
            else items.forEach(function (el) { var vv = videoOf(el); if (vv) vv.pause(); });
          });
        }, { threshold: 0.25 });
        io.observe(root);
      }
      show(0);
    });
  }

  /* ---- cart: add via AJAX and open the drawer, never leave the page ---- */
  function openCartDrawer() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') { d.open(); return true; }
    if (d) { d.classList.add('animate', 'active'); document.body.classList.add('overflow-hidden'); return true; }
    return false;
  }

  function refreshCartUI() {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + '?sections=cart-drawer'
                                                 : '/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawer');
        var live  = document.querySelector('#CartDrawer');
        if (fresh && live) live.innerHTML = fresh.innerHTML;
        var wrap = document.querySelector('cart-drawer');
        var freshWrap = doc.querySelector('cart-drawer');
        if (wrap && freshWrap) wrap.classList.toggle('is-empty', freshWrap.classList.contains('is-empty'));
      })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('.sd-ico__count, .sd-sticky__cart i').forEach(function (n) {
          n.textContent = cart.item_count;
          if (n.matches('.sd-sticky__cart i')) n.style.display = cart.item_count ? '' : 'none';
        });
      })
      .catch(function () {});
  }

  function ajaxCart() {
    if (!once(document.body, 'sdCartBound')) return;

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var buyNow = form.hasAttribute('data-sd-buy-form');
      var btn = form.querySelector('button[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = buyNow ? 'Just a sec…' : 'Adding…'; }

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form),
                              headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          /* Buy now skips the drawer and goes straight to checkout. */
          if (buyNow) { window.location.href = '/checkout'; return null; }
          return refreshCartUI().then(openCartDrawer);
        })
        .catch(function () { form.submit(); })
        .finally(function () {
          if (btn && !buyNow) { btn.disabled = false; btn.textContent = label; }
        });
    });

    /* every cart entry point opens the drawer instead of navigating */
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-sd-cart-open]');
      if (!t) return;
      e.preventDefault();
      refreshCartUI().then(openCartDrawer);
    });
  }

  function init() {
    stickyHeader(); announcement(); drawer(); reveal(); trackOrder(); heroShots(); shoppableVideo(); heroSlides(); carousels(); videoReviews(); ajaxCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  /* Shopify theme editor re-renders sections without a page load */
  document.addEventListener('shopify:section:load', init);
})();
